// extracted by mini-css-extract-plugin
export default {"points":"player1Points_points__Z95bl","points__star":"player1Points_points__star__1czMH"};